// =============================================================================
// MeuDriver — ProBadge
// Badge "Pro" exibido ao lado do nome do instrutor.
// =============================================================================

import { Star } from 'lucide-react'
import { cn } from '@/lib/utils'

interface ProBadgeProps {
  className?: string
}

export function ProBadge({ className }: ProBadgeProps) {
  return (
    <span
      data-testid="pro-badge"
      className={cn(
        'inline-flex items-center gap-1 rounded-full bg-brand-100 px-2 py-0.5 text-[11px] font-semibold text-brand-700 ring-1 ring-brand-200',
        className,
      )}
    >
      <Star className="h-3 w-3 shrink-0 fill-brand-600" />
      Pro
    </span>
  )
}
